import * as dates from 'date-arithmetic';
import React from 'react';
import { Navigate } from 'react-big-calendar';
import TimeGrid from 'react-big-calendar/lib/TimeGrid';

const CustomWeekView = (props) => {
  const { date } = props;
  const range = CustomWeekView.range(date);

  return <TimeGrid {...props} range={range} eventOffset={15} />;
};

CustomWeekView.range = (date) => {
  const start = dates.startOf(date, 'day');
  const end = dates.add(start, 2, 'day');

  let current = start;
  const range = [];

  while (dates.lte(current, end, 'day')) {
    range.push(current);
    current = dates.add(current, 1, 'day');
  }

  return range;
};

CustomWeekView.navigate = (date, action) => {
  switch (action) {
    case Navigate.PREVIOUS:
      return dates.add(date, -3, 'day');

    case Navigate.NEXT:
      return dates.add(date, 3, 'day');

    default:
      return date;
  }
};

CustomWeekView.title = (date) => {
  const option1 = { month: 'short' };
  const option2 = { day: 'numeric' };
  const today = new Date(date);
  today.setDate(today.getDate() + 2);
  return `${date.toLocaleDateString(undefined, option1)} ${date.toLocaleDateString(undefined, option2)}-${today.toLocaleDateString(undefined, option2)}`;
};

export default CustomWeekView;
